var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTezos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for Tezos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C7DF7",
    d: "M19.18 32c-2.28 0-3.95-.55-5-1.65a5.1 5.1 0 0 1-1.57-3.56c-.01-.4.08-.8.28-1.17.17-.31.43-.57.75-.75a2.62 2.62 0 0 1 2.33 0 2 2 0 0 1 .75.75c.2.36.3.76.28 1.17.02.5-.12.98-.4 1.38-.23.33-.57.57-.95.7.38.47.9.8 1.5.93.67.2 1.35.3 2.05.3.91 0 1.8-.27 2.57-.78a4.5 4.5 0 0 0 1.68-2.27c.38-1.1.57-2.25.55-3.4a9.34 9.34 0 0 0-.6-3.55 4.37 4.37 0 0 0-4.23-2.91c-.77.07-1.52.32-2.17.73l-1.6.81v-.8l7.21-9.68h-10v10.04a3.6 3.6 0 0 0 .55 2.05 1.9 1.9 0 0 0 1.68.81 2.8 2.8 0 0 0 1.66-.59 6 6 0 0 0 1.57-1.66.37.37 0 0 1 .24-.1c.18.02.34.1.47.2a1 1 0 0 1 .26.68c-.02.17-.05.34-.1.5-.35.86-.94 1.6-1.7 2.13-.72.48-1.56.74-2.41.74-2.17 0-3.67-.43-4.5-1.29a4.8 4.8 0 0 1-1.24-3.5V8.25H4V6.38h5.11V2.12L7.94.95V0h3.4l1.27.66v5.72l13.21-.04 1.32 1.32-8.1 8.14c.48-.2 1-.32 1.53-.37 1.03.04 2.05.33 2.96.84a6.08 6.08 0 0 1 2.55 2.28c.55.84.94 1.77 1.15 2.74.17.78.26 1.56.27 2.36 0 1.5-.34 3-1 4.35a6.39 6.39 0 0 1-3 3 9.7 9.7 0 0 1-4.32 1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTezos);
export default __webpack_public_path__ + "static/media/tezos.6a44ce16bfb911003f1d9d2dfa5dfd66.svg";
export { ForwardRef as ReactComponent };